<template>
  <div>
    <v-card style="border-radius:12px" v-if="$route.name != 'Bills'">
      <v-toolbar text color="white" v-if="false">
        <v-toolbar-title>Faturas</v-toolbar-title>
        <v-divider class="mx-4" inset vertical ></v-divider>
        <div class="flex-grow-1"></div>
        <!-- <v-btn rounded color="primary" dark class="mb-2" @click="dialog_supplier=true">Novo</v-btn> -->

      </v-toolbar>

      <v-card-text>
        <v-btn color="primary" @click="dialog_create_bill = true">Criar fatura avulsa</v-btn>
        <v-row justify="center" v-if="!all_client_bills">
          <v-col cols="12" align="center">
            <card-loading ></card-loading>
          </v-col>
        </v-row>
        <index-table :headers="headers" :items="all_client_bills" :deletion_enabled="false" @editing="editing($event)" @deleting="deleting($event)"></index-table>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog_edit_bill" scrollable  max-width="500px" transition="dialog-transition" v-if="dialog_edit_bill" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Boleto </div>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeBillModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn color="primary" v-if="!one_client_bill.is_editing && can_edit" @click.stop="one_client_bill.is_editing = true" rounded>editar</v-btn>
        </v-card-title>
        <v-card-text class="pb-1">
          <template v-if="!one_client_bill.is_editing">
            <v-row justify="space-between" class="px-3">
              <v-chip pill class="my-2">
                <v-avatar left :class="status[one_client_bill.status] ? status[one_client_bill.status].avatar_color : 'grey'">
                  <v-icon>mdi-account</v-icon>
                </v-avatar>
                {{one_client_bill.client_name}}
              </v-chip>
              <template v-if="pay_manually.dialog != true">
                <v-chip pill class="my-2">
                  <v-avatar left :class="status[one_client_bill.status] ? status[one_client_bill.status].avatar_color : 'grey'">
                    <v-icon>{{status[one_client_bill.status] ? status[one_client_bill.status].icon : 'mdi-help'}}</v-icon>
                  </v-avatar>
                  {{status[one_client_bill.status] ? status[one_client_bill.status].text : one_client_bill.status}}
                </v-chip>
                <v-chip pill class="my-2" @click="pay_manually.dialog = true" v-if="!one_client_bill.is_editing && can_edit">
                  <v-avatar left class="green">
                    <v-icon>{{status[one_client_bill.status] ? status[one_client_bill.status].icon : 'mdi-help'}}</v-icon>
                  </v-avatar>
                  Pagamento Manual
                </v-chip>
                <v-chip
                  pill
                  class="my-2"
                  style="cursor:pointer"
                  @click="openBoleto"
                  v-if="!one_client_bill.is_editing && one_client_bill.secure_url"
                >
                  Ver boleto
                  <v-avatar right class="blue">
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-avatar>
                </v-chip>
                <v-chip
                  pill
                  class="my-2"
                  style="cursor:pointer"
                  @click="copyBillUrl(one_client_bill.id)"
                  v-if="!one_client_bill.is_editing"
                >
                  Copiar Link
                  <v-avatar right class="purple">
                    <v-icon>mdi-link</v-icon>
                  </v-avatar>
                </v-chip>
              </template>
            </v-row>
            <template v-if="pay_manually.dialog != true">
              <v-text-field :value="new Date(`${one_client_bill.created_at.split('T')[0]}T12:00:00Z`).toLocaleDateString('pt-BR')" prepend-icon="mdi-information" readonly label="Criado em"></v-text-field>
              <v-text-field :value="one_client_bill.ammount" v-currency="currency" readonly prepend-icon="mdi-currency-brl" label="Valor"></v-text-field>
              <v-text-field :value="new Date(`${one_client_bill.due_date}T12:00:00Z`).toLocaleDateString('pt-BR')" label="Vencimento" prepend-icon="mdi-calendar" readonly></v-text-field>
              <v-text-field v-if="one_client_bill.invoice_id" :value="one_client_bill.invoice_id" readonly prepend-icon="mdi-identifier" label="Invoice ID"></v-text-field>
              <v-alert v-if="one_client_bill.status === 'error' && one_client_bill.error_message" type="error" class="mb-3">
                <strong>Erro:</strong> {{ one_client_bill.error_message }}
              </v-alert>
              <v-textarea v-if="one_client_bill.status == 'manual_payed'" readonly filled label="Comentário" rows="1" prepend-inner-icon="mdi-comment" :value="one_client_bill.comment" ></v-textarea>
              <v-textarea v-if="can_edit" readonly filled label="Linha digitável" rows="2" prepend-inner-icon="mdi-barcode" :value="one_client_bill.digitable_line" ></v-textarea>

            </template>
            <template v-if="pay_manually.dialog == true">
              <v-text-field v-model="pay_manually.comment" label="Comentário" prepend-icon="mdi-comment"></v-text-field>
              <v-row class="pa-3" justify="space-between">
                <v-btn class="mr-3" color="error"  @click="pay_manually.dialog = false" rounded><v-icon left>mdi-cancel</v-icon>Cancelar</v-btn>
                <v-btn class="mr-3" color="success"  :disabled="!pay_manually.comment" @click="submitBill()" rounded><v-icon left>mdi-content-save</v-icon>Confirmar</v-btn>
              </v-row>
            </template>
          </template>




          <template v-if="one_client_bill.is_editing">
            <v-dialog ref="dialogDueDate" :return-value.sync="one_client_bill.new_due_date" width="290px" >
              <template v-slot:activator="{ on }">
                <v-text-field :value="new Date(`${one_client_bill.new_due_date}T12:00:00Z`).toLocaleDateString('pt-BR')" label="Novo vencimento" prepend-icon="mdi-calendar" :readonly="one_client_bill.is_editing" v-on="on" ></v-text-field>
              </template>
              <v-date-picker v-model="one_client_bill.new_due_date" locale="pt-BR" scrollable :min="minDate">
                <v-spacer></v-spacer>
                <!-- <v-btn text color="primary" @click="modal = false">Cancelar</v-btn> -->
                <v-btn text color="primary" @click="$refs.dialogDueDate.save(one_client_bill.new_due_date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>

            <v-alert type="info" :value="true">
              Ao alterar a data de vencimento, será gerado um novo boleto no sistema PagarMe.
              Assim, você deve copiar o novo link e reenviar para o email do cliente manualmente.
            </v-alert>
          </template>

        </v-card-text>
        <v-card-actions class="justify-end" v-if="one_client_bill.is_editing">
          <v-btn @click="one_client_bill.is_editing = false" color="error"> <v-icon left>mdi-close</v-icon> Cancelar</v-btn>
          <v-btn @click="submitBill()" color="success"> <v-icon left>mdi-content-save</v-icon> Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_create_bill" scrollable  max-width="500px" transition="dialog-transition" v-if="dialog_create_bill" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Novo Boleto </div>
        </v-card-title>
        <v-card-text class="pb-1">
          <template>
            <v-dialog  ref="dialogPicker" v-model="modal" :return-value.sync="create_bill.due_date" persistent width="290px"  >
              <template v-slot:activator="{ on }">
                <v-text-field  :rules="[rules.required]"  :value="create_bill.due_date?  new Date(`${create_bill.due_date}T12:00:00Z`).toLocaleDateString('pt-BR') : ''" label="Data de Vencimento" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker v-model="date" scrollable :min="minDate">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dialogPicker.save(date)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
            <v-text-field :rules="[rules.required, rules.minAmount]"  v-currency="currency" v-model="create_bill.ammount" prepend-icon="mdi-currency-brl" label="Valor"></v-text-field>
            <v-textarea :rules="[rules.required]"  v-model="create_bill.comment" filled label="Comentário" prepend-icon="mdi-comment" auto-grow></v-textarea>
          </template>

        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn @click="dialog_create_bill = false; create_bill= {}" color="error"> <v-icon left>mdi-close</v-icon> Cancelar</v-btn>

          <v-btn @click="createBill()" :disabled="!isValidForm"  color="success"> <v-icon left>mdi-content-save</v-icon>Criar Fatura</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading" :loadText="loadingText"></dialog-loading>
  </div>
</template>

<script>

import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import Api from '../../../api'
import { CurrencyDirective, parseCurrency } from 'vue-currency-input'




export default {
  name: 'ClientBills',
  directives: {
    currency: CurrencyDirective
  },
  components: {
    indexTable: ()=> import('../../shared/IndexTable'),
  },
  data() {
    return {
      all_client_bills: null,
      one_client_bill: {
        // is_editing: false,
      },
      date: null,
      modal: false,
      dialog_edit_bill: false,
      create_bill:{ },
      dialog_create_bill: false,

      loading: false,
      loadingText: null,

      status:{
        pending: {icon: "mdi-account-clock", text: "Pendente", avatar_color: "orange"},
        paid: {icon: "mdi-account-check", text: "Pago", avatar_color: "green"},
        cancelled: {icon: "mdi-cancel", text: "Cancelado", avatar_color: "grey"},
        overdue: {icon: "mdi-alarm-off", text: "Atrasado", avatar_color: "red"},
        manual_payed: {icon: "mdi-hand", text: "Pg. Manual", avatar_color: "blue"},
        error: {icon: "mdi-alert-circle", text: "Erro", avatar_color: "red darken-2"},
        processing: {icon: "mdi-cog", text: "Processando", avatar_color: "blue-grey"},
      },


      rules: {
        required: v => !!v || 'Campo é necessário',
        minAmount: v => {
          const numericValue = typeof v === 'string' ? parseFloat(v.replace(/[^\d,]/g, '').replace(',', '.')) : parseFloat(v);
          return numericValue >= 5 || 'Valor mínimo é R$ 5,00';
        }
      },

      currency:{
        currency: null,
        locale: 'pt-BR',
        autoDecimalMode: true,
        decimalLength: 2,
        distractionFree:false,
      },

      pay_manually:{
        dialog: false,
        comment: null
      },

      headers:[
        // { text: 'ID', width: '5%' ,align: 'left', sortable: false, value: 'id'},
        // { text: 'Invoice ID', width: '30%' ,align: 'left', sortable: false, value: 'invoice_id'},
        { text: 'Status', width: '10%' ,align: 'center', sortable: true, value: 'status'},
        // { text: 'Cliente', width: '20%' ,align: 'left', sortable: true, value: 'client_name'},
        { text: 'Valor', width: '10%' ,align: 'center', sortable: true, value: 'ammount'},
        // { text: 'Linha digitavel', width: '30%' ,align: 'center', sortable: false, value: 'digitable_line'},
        // { text: 'URL Barcode', width: '30%' ,align: 'center', sortable: false, value: 'barcode_url'},
        { text: 'Venc.', width: '10%' ,align: 'center', sortable: true, value: 'due_date'},
        { text: 'Criado em', width: '10%' ,align: 'center', sortable: true, value: 'created_at'},
        { text: 'URL Segura', width: '10%' ,align: 'center', sortable: false, value: 'secure_url'},
        { text: 'Ação', width: '10%' ,align: 'center', sortable: false, value: 'action'},
      ],
    }
  },
  methods: {
    createBill(){
      // Validar valor mínimo antes de prosseguir
      const numericValue = typeof this.create_bill.ammount === 'string'
        ? parseFloat(this.create_bill.ammount.replace(/[^\d,]/g, '').replace(',', '.'))
        : parseFloat(this.create_bill.ammount);

      if (numericValue < 5) {
        this.$swal({
          title: 'Valor Inválido',
          text: 'O valor mínimo para criação de fatura é R$ 5,00',
          type: 'error'
        });
        return;
      }

      this.loading = true
      this.loadingText = 'Criando Boleto'
      this.create_bill.ammount = parseCurrency(this.create_bill.ammount, {})
      this.create_bill.comment = "Fatura criada manualmente!\n" + this.create_bill.comment
      if(this.dialog_create_bill){
        Api.Bill.create_client_bill(this.$route.params.id, this.create_bill)
        .then(r=>r.data)
        .then(bill=>{
          this.one_client_bill = {...bill.data.attributes}
          // this.one_client_bill.is_editing =false
          this.loading = false
          this.loadingText = null
          this.dialog_edit_bill = true
          if(this.$route.name != 'Bills'){
            this.indexBill()
          }
          this.updateBillResp({was_good: true, msg: ''})
          this.dialog_create_bill = false
          this.create_bill = {}

          // SweetAlert de sucesso
          this.$swal({
            title: 'Boleto Criado!',
            text: 'Boleto criado com sucesso. Você pode visualizar os detalhes na modal aberta.',
            type: 'success',
            timer: 3000,
            showConfirmButton: false
          })

        }).catch(err=>{
          this.loading = false
          this.loadingText = null
          this.updateBillResp({was_good: false, msg: 'Erro: ' + err.data.errors[0]})
          console.error('erro ao Criar billde bill');
          console.error({err});

          // SweetAlert de erro
          this.$swal({
            title: 'Erro na Criação!',
            text: err.data && err.data.errors ? err.data.errors[0] : 'Erro inesperado ao criar boleto',
            type: 'error',
            confirmButtonText: 'OK'
          })
        })

      }


    },
    indexBill() {
      this.loading = true;
      this.loadingText = 'Carregando';

      // Preparar parâmetros da API
      const apiParams = {
        page: 1,
        per_page: 50, // Mostrar mais itens por padrão para clientes individuais
        sort_by: 'created_at',
        sort_direction: 'desc'
      }

      Api.Bill.client_bill_index(this.$route.params.id, apiParams)
        .then(r=>r.data)
        .then(response=>{
          this.all_client_bills = response.data ? response.data.map(o=>o.attributes) : [];
          this.loading = false;
          this.loadingText = null;
        }).catch(err=>{
          this.loading = false;
          this.loadingText = null;
          console.error('Erro ao carregar faturas do cliente:', err);
        })
    },
    editing(id) {
      this.loading = true
      this.loadingText = "Carregando"

      // Atualizar URL com bill_id sem recarregar a página
      const query = { ...this.$route.query, bill_id: id };
      this.$router.replace({ query });

      Api.Bill.client_bill_show(this.$route.params.id, id)
        .then(r=>r.data)
        .then(bill=>{
          this.one_client_bill = {...bill.data.attributes, is_editing: false}
          // this.one_client_bill.is_editing =false
          this.loading = false
          this.loadingText = null
          this.dialog_edit_bill = true
        }).catch(err=>{
          this.loading = false
          this.loadingText = null
          console.log('erro em index de bill');
          console.log({err});
        })
    },
    submitBill(){
      this.loading = true
      this.loadingText = 'Salvando'
      let obj_update = {}
      if(this.pay_manually.dialog == true){
        obj_update = {
          id: this.one_client_bill.id,
          pay_manually: true,
          comment: this.pay_manually.comment
        }

      } else{
        obj_update = {
          id: this.one_client_bill.id,
          due_date: this.one_client_bill.new_due_date,

        }

      }
      Api.Bill.update(obj_update)
        .then(r=>r.data)
        .then(bill=>{
          this.one_client_bill = {...bill.data.attributes, is_editing: false}
          // this.one_client_bill.is_editing =false
          this.loading = false
          this.loadingText = null
          this.dialog_edit_bill = true
          if(this.$route.name != 'Bills'){
            this.indexBill()
          }
          this.updateBillResp({was_good: true, msg: ''})
          // if(this.$route.name=='Bills')
          if(this.pay_manually.dialog == true) {
            this.pay_manually = {
              dialog: false,
              comment: null
            }
            // SweetAlert para pagamento manual
            this.$swal({
              title: 'Pagamento Registrado!',
              text: 'Pagamento manual registrado com sucesso.',
              type: 'success',
              timer: 3000,
              showConfirmButton: false
            })
          } else {
            // SweetAlert para atualização de data
            this.$swal({
              title: 'Data Atualizada!',
              text: 'Data de vencimento atualizada com sucesso. Um novo boleto foi gerado.',
              type: 'success',
              timer: 3000,
              showConfirmButton: false
            })
          }
          // this.dialog_edit_bill = true

        }).catch(err=>{
          this.loading = false
          this.loadingText = null
          this.updateBillResp({was_good: false, msg: 'Erro: ' + err.data.errors[0]})
          console.log('erro em index de bill');
          console.log({err});

          // SweetAlert de erro
          this.$swal({
            title: 'Erro na Atualização!',
            text: err.data && err.data.errors ? err.data.errors[0] : 'Erro inesperado ao atualizar boleto',
            type: 'error',
            confirmButtonText: 'OK'
          })
        })
    },

    openBoleto() {
      if (this.one_client_bill.secure_url) {
        window.open(this.one_client_bill.secure_url, '_blank');
      }
    },

    openBillFromUrl() {
      // Verificar se há um parâmetro bill_id na URL
      const billId = this.$route.query.bill_id;
      if (billId) {
        this.editing(billId);
      }
    },

    closeBillModal() {
      // Fechar modal e remover parâmetro da URL
      this.dialog_edit_bill = false;
      this.one_client_bill = null;

      // Remover bill_id da URL sem recarregar a página
      const query = { ...this.$route.query };
      delete query.bill_id;
      this.$router.replace({ query });
    },

    generateBillUrl(billId) {
      // Gerar URL direta para uma fatura específica
      const baseUrl = window.location.origin;
      const currentPath = this.$route.path;
      return `${baseUrl}${currentPath}?bill_id=${billId}`;
    },

    copyBillUrl(billId) {
      // Copiar URL da fatura para a área de transferência
      const url = this.generateBillUrl(billId);
      navigator.clipboard.writeText(url).then(() => {
        this.$swal({
          title: 'Sucesso!',
          text: 'URL copiada para a área de transferência',
          type: 'success',
          timer: 2000
        });
      }).catch(() => {
        // Fallback para navegadores mais antigos
        const textArea = document.createElement('textarea');
        textArea.value = url;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        this.$swal({
          title: 'Sucesso!',
          text: 'URL copiada para a área de transferência',
          type: 'success',
          timer: 2000
        });
      });
    },

    ...mapActions({
      // function: 'Module/action'
    }),
    ...mapMutations({
      updateBillResp: 'Bill/updateResponse'
    })
  },
  computed: {
    can_edit() {
      return !['paid', 'cancelled', 'manual_payed'].includes(this.one_client_bill.status)
    },
    minDate() {
      // Retorna a data de amanhã (um dia após hoje) no formato YYYY-MM-DD
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      return tomorrow.toISOString().split('T')[0];
    },
    ...mapState({
      oneClientVuex: state=> state.Client.oneClient,
      // oneUser: state => state.User.oneUser
      // data: state=> state.Module.state_var
    }),
    isValidForm() {
      if (!this.create_bill.comment || !this.create_bill.due_date || !this.create_bill.ammount) {
        return false;
      }

      // Verificar se o valor é maior ou igual a 5
      const numericValue = typeof this.create_bill.ammount === 'string'
        ? parseFloat(this.create_bill.ammount.replace(/[^\d,]/g, '').replace(',', '.'))
        : parseFloat(this.create_bill.ammount);

      return numericValue >= 5;
    }
  },
  created () {
    if(this.$route.name != 'Bills'){
      this.indexBill()
    }
  },
  mounted() {
    // Verificar se deve abrir uma fatura específica via URL
    this.openBillFromUrl();
  },
  watch: {
    '$route.query.bill_id'(newBillId, oldBillId) {
      // Quando o bill_id muda na URL, abrir a fatura correspondente
      if (newBillId && newBillId !== oldBillId) {
        this.editing(newBillId);
      } else if (!newBillId && this.dialog_edit_bill) {
        // Se bill_id foi removido da URL, fechar a modal
        this.dialog_edit_bill = false;
        this.one_client_bill = null;
      }
    },
    'one_client_bill.is_editing'(nv,ov) {
      if (nv){
        this.one_client_bill = {...this.one_client_bill, new_due_date: this.one_client_bill.due_date}
      } else if (nv == false){
      }
    },
    dialog_edit_bill(nv,ov) {
      if (nv){

      } else if (nv == false){
        this.one_client_bill = null
      }
    }
  },
}
</script>

<style scoped>

</style>